module.exports = __webpack_public_path__ + "static/media/СЗФО_2018.06e9c6a4.png";